export default class TyreHotel {
  public bookingServiceId: number
  public productDescription: string
}
